<template>
  <div class="impersonate-layout">
    <div class="impersonate-card">
      <!-- Logo -->
      <div class="impersonate-logo">
        <img
          src="@/assets/img/mydessk-black.svg"
          alt="Mydessk"
          @error="onLogoError"
        />
      </div>

      <!-- Loading -->
      <div v-if="loading" class="impersonate-state">
        <div class="impersonate-spinner"></div>
        <p class="impersonate-state__text">Verificando enlace de acceso...</p>
      </div>

      <!-- Error -->
      <div v-else-if="error" class="impersonate-state impersonate-state--error">
        <div class="impersonate-state__icon">✕</div>
        <h2 class="impersonate-state__title">Enlace inválido</h2>
        <p class="impersonate-state__text">{{ error }}</p>
        <router-link to="/login" class="impersonate-btn"
          >Volver al login</router-link
        >
      </div>

      <!-- Success (transitioning) -->
      <div v-else class="impersonate-state impersonate-state--success">
        <div class="impersonate-state__icon">✓</div>
        <h2 class="impersonate-state__title">Acceso verificado</h2>
        <p class="impersonate-state__text">
          Entrando al perfil de <strong>{{ userName }}</strong
          >...
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import AuthServices from "../../services/AuthServices";

export default {
  name: "ImpersonatePage",

  props: {
    token: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      loading: true,
      error: null,
      userName: ""
    };
  },

  async created() {
    await this.redeem();
  },

  methods: {
    async redeem() {
      try {
        const response = await AuthServices.redeemImpersonation(this.token);
        const { success, token, user, message } = response.data;

        if (!success) {
          this.error = message || "El enlace ha expirado o ya fue utilizado.";
          this.loading = false;
          return;
        }

        this.userName = user.name || "usuario";
        this.loading = false;

        // Store session exactly as a normal login
        this.$store.commit("setUser", { ...user, token });

        // Brief pause so the user sees the success state
        setTimeout(() => {
          this.$router.replace({ name: "dashboard" });
        }, 800);
      } catch (err) {
        const msg = err?.response?.data?.message;
        this.error = msg || "El enlace ha expirado o ya fue utilizado.";
        this.loading = false;
      }
    },

    onLogoError(e) {
      e.target.style.display = "none";
    }
  }
};
</script>

<style scoped>
.impersonate-layout {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
}

.impersonate-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 48px 40px;
  width: 100%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
}

.impersonate-logo {
  margin-bottom: 32px;
}

.impersonate-logo img {
  height: 28px;
  width: auto;
}

.impersonate-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.impersonate-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e5e7eb;
  border-top-color: #1f2937;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  margin-bottom: 8px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.impersonate-state__icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 4px;
}

.impersonate-state--success .impersonate-state__icon {
  background: #d1fae5;
  color: #065f46;
}

.impersonate-state--error .impersonate-state__icon {
  background: #fee2e2;
  color: #991b1b;
}

.impersonate-state__title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.impersonate-state__text {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.impersonate-btn {
  margin-top: 8px;
  display: inline-block;
  background: #1f2937;
  color: #fff;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.15s;
}

.impersonate-btn:hover {
  background: #111827;
}
</style>
